"use client";

import { colorOddsChanges } from "@/utils/matchInfo";

function normalizeTrend(trend) {
  if (trend === "up") return "increased";
  if (trend === "down") return "decreased";
  return trend ?? "unchanged";
}

export default function StakeOutcomeOddsButton({ label, odds, trend = "unchanged" }) {
  const normalizedTrend = normalizeTrend(trend);

  return (
    <button
      type="button"
      className="group flex min-h-[54px] w-full flex-col items-start justify-center rounded-md px-3 py-2 text-left transition-all duration-100 stake-btn-hover"
    >
      <span className="text-sm truncate max-w-full text-[var(--theme-text)] mb-1">
        {label}
      </span>
      <div className="flex items-center gap-1 mt-auto">
        <span className={`text-sm font-bold transition-colors ${colorOddsChanges(normalizedTrend)} group-hover:text-[var(--theme-text)]`}>
          {odds || "-"}
        </span>
        {normalizedTrend === "increased" && <span key={odds} className="stake-odds-status--up" />}
        {normalizedTrend === "decreased" && <span key={odds} className="stake-odds-status--down" />}
      </div>
    </button>
  );
}